import React, { useState } from 'react';
import '../../styles/Boutique/Category.css';
import '../../styles/Boutique/Cart.css';
import '../../styles/Boutique/BoutiqueLayout.css';
import '../../styles/Boutique/Products.css';
import cartpng from '../../assets/boutique/cart.png';

const ProductCard = ({ product, addToCart }) => {
  const [selectedSize, setSelectedSize] = useState(product.sizes ? product.sizes[0] : null);
  const [quantity, setQuantity] = useState(1);

  const handleAddToCart = () => {
    if (product.soldout) return;
    addToCart(product, Number(quantity), selectedSize);
  };

  return (
    <div className={`product-card ${product.soldout ? 'is-soldout' : ''}`}>
      <div className="product-image">
        {product.soldout && (
          <span className="soldout-badge">Épuisé</span>
        )}
        {product.image ? (
          <img src={product.image} alt={product.name} />
        ) : (
          <div className="placeholder">No Image</div>
        )}
      </div>
      <h3 className="product-title">{product.name}</h3>
      <div className="product-price">{product.price.toFixed(2)} €</div>
      {product.sizes && (
        <div className="size-selector">
          <label>Taille :</label>
          <select
            value={selectedSize || ''}
            onChange={(e) => setSelectedSize(e.target.value)}
            disabled={product.soldout}
          >
            {product.sizes.map(size => (
              <option key={size} value={size}>{size}</option>
            ))}
          </select>
        </div>
      )}
      <div className="quantity-selector">
        <label>Quantité :</label>
        <input
          type="number"
          name="quantity"
          min="1"
          value={quantity}
          onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
          disabled={product.soldout}
        />
      </div>
      <button 
        className="add-to-cart" 
        onClick={handleAddToCart}
        disabled={product.soldout}
      >
        {product.soldout ? 'Épuisé' : 'Ajouter au panier'}
        {!product.soldout && <img src={cartpng} alt="Ajouter au panier" />}
      </button>
    </div>
  );
};

export default ProductCard;